export default __webpack_public_path__ + "static/media/complex-img.049107c8.jpg";